export default __webpack_public_path__ + "static/media/chart-fi-analytics.28135603.svg";